import clsx from "clsx";
import type React from "react";

export type FieldContainerProps = React.HTMLAttributes<HTMLDivElement>;

export const FieldContainer = ({ className, children, ...props }: FieldContainerProps) => {
  return (
    <div className={clsx("tw-mb-4", className)} {...props}>
      {children}
    </div>
  );
};
